<template>
  <div class="appHouseholdManage">
    <div class="filters">
      <el-form :inline="true">
        <!-- 选择日期 -->
        <el-form-item :label="$t('lang.lab_receivePeriod')">
         <!--  <el-date-picker
            v-model="datevalues"
            type="daterange"
            :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')"
            :end-placeholder="$t('lang.lab_endDate')"
            value-format="timestamp"
          ></el-date-picker> -->

        <el-date-picker type="date" :placeholder="$t('lang.lab_startDate')"   value-format="timestamp" v-model="startTime"></el-date-picker>
          <span style="padding: 0 1px">至</span>
        <el-date-picker type="date" :placeholder="$t('lang.lab_endDate')"  value-format="timestamp" v-model="endTime" ></el-date-picker>

        </el-form-item>
        <!-- 选择楼号 -->
        <el-form-item>
          <el-select v-model="houseId" @change="selectUnit" filterable>
            <el-option key :label="$t('lang.lab_floorName')" value></el-option>
            <el-option
              v-for="(item,index) in floorList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择单元号 -->
        <el-form-item>
          <el-select v-model="unitid" @change="selectRoom" filterable>
            <el-option key :label="$t('lang.lab_unitName')" value></el-option>
            <el-option
              v-for="(item,index) in unitList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择房间号 -->
        <el-form-item>
          <el-select v-model="roomid" filterable>
            <el-option key :label="$t('lang.lab_roomName')" value></el-option>
            <el-option
              v-for="(item,index) in roomList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 身份 -->
        <!-- <el-form-item>
          <el-select
            class="select"
            v-model="user"
            :placeholder="$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[0].label')"
          >
            <el-option
              v-for="item in Identitys"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 欠款合计筛选 -->
        <el-form-item>
          <el-select
            class="select"
            v-model="receiveArrearSelect"
            placeholder="请选择欠款合计条件">
              <el-option
              v-for="item in receiveArrearSelects"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            class="searchInput"
            v-model="searchFeeName"
            :placeholder="$t('lang.lab_feeName')"
          ></el-input>
        </el-form-item>
        <!-- 关键字 -->
        <el-form-item>
          <el-input
            class="seachInput"
            v-model="keyword"
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_username')"
          ></el-input>
        </el-form-item>
        <el-switch style="margin-left: 10px; margin-right: 10px;" v-if="isRelationButton==1" active-text="收费减免" v-model="switchValue"> </el-switch>
        <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
        <el-button type="primary"  @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>
        <!-- 调整按钮 -->
        <el-button type="primary" v-if="isFeeManager===1" :disabled="!multipleSelection.length" @click="adjust()">{{$t('lang.lab_adjust')}}</el-button>
        <el-button type="primary" v-if="isFeeManager===1" :disabled="!multipleSelection.length" @click="openBatchResponsiblePerson()">批量责任人</el-button>
        <el-button type="primary" v-if="isFeeManager===1" :disabled="!multipleSelection.length" @click="openBatchReasonArrears()">批量欠款原因</el-button>
        <el-button type="primary" v-if="isFeeManager===1" :disabled="!multipleSelection.length" @click="batchDelete()">批量删除</el-button>
        <el-button type="primary"  :disabled="!canCombinedPay" @click="combinedPay()">合并缴费</el-button>
      </el-form>
    </div>
    <el-card>
      <div slot="header" class="clearfix">
        <el-row style="margin-left:5%;text-align: start;">
          <el-col :span="8">{{$t('lang.lab_receiveCount')}}：{{receiveAmountCount}}</el-col>
          <el-col :span="8">{{$t('lang.lab_receiveArrears')}}：{{revAmountCount}}</el-col>
          <el-col :span="8">{{$t('lang.lab_receivedCount')}}：{{paidAmountCount}}</el-col>
        </el-row>
      </div>
      <el-table
        :data="tableData"
        class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="appHouseholdManageListcheckbox"></el-table-column>
        <!-- <el-table-column align="center" width="55" label="操作">
          <template slot-scope="scope">
            <el-radio class="radio" v-model="selectCode" :label="scope.row.rId" @click.native.prevent="clikcRadio(scope.row.rId)">
                  <span></span> 
              </el-radio>
          </template>
        </el-table-column> -->
        <!-- 序号 -->
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="55"
        ></el-table-column>
        <!-- 用户名 -->
        <el-table-column width="100" prop="ownerName" :label="$t('lang.lab_username')"></el-table-column>
        <!-- 手机 -->
        <el-table-column prop="mobile" width="120" :label="$t('lang.lab_phone')"></el-table-column>
        <!-- 小区 -->
        <el-table-column prop="gardenName"  width="100" :label="$t('lang.lab_village')"></el-table-column>
        <!-- 楼号 -->
        <el-table-column width="60" prop="houseName" :label="$t('lang.lab_buildingnum')"></el-table-column>
        <!-- 单元号 -->
        <el-table-column width="60" prop="unitName" :label="$t('lang.resourUnit')"></el-table-column>
        <!-- 房间号 -->
        <el-table-column prop="roomName" :label="$t('lang.lab_roomnum')"></el-table-column>
        <!-- 建筑面积 -->
        <el-table-column prop="buildArea" :label="$t('lang.lab_preHouseholdArea')"></el-table-column>
        <el-table-column prop="feeName" :label="$t('lang.feePay.lab_feeConfigName')"></el-table-column>
        <!-- 单价 -->
        <el-table-column width="50" prop="squarePrice" :label="$t('lang.lab_price')"></el-table-column>
        <!-- 费用间 -->
        <el-table-column prop="period" :label="$t('lang.lab_feePeriodCount')"></el-table-column>
        <!-- 计费开始时间 -->
        <el-table-column prop="beginDate" width="110" :label="$t('lang.lab_startTimes')">
          <template slot-scope="scope">{{scope.row.beginDate|timeYMD}}</template>
        </el-table-column>
        <!-- 计费终止时间 -->
        <el-table-column prop="minEndDate" width="110" :label="$t('lang.lab_endTimes')">
          <template slot-scope="scope">{{scope.row.minEndDate|timeYMD}}</template>
        </el-table-column>
        <!-- 欠费开始时间 -->
        <el-table-column width="110" prop="minStartDate" :label="$t('lang.lab_oweStartTime')">
          <template slot-scope="scope">{{scope.row.minStartDate|timeYMD}}</template>
        </el-table-column>
        <!-- 计欠费终止时间 -->
        <el-table-column width="110" prop="minEndDate" :label="$t('lang.lab_oweEndTimes')">
          <template slot-scope="scope">{{scope.row.minEndDate|timeYMD}}</template>
        </el-table-column>
        <el-table-column prop="receiveAmount" :label="$t('lang.lab_amountOwed')">
          <template slot-scope="scope">{{scope.row.receiveAmount|rounding}}</template>
        </el-table-column>
        <!-- 应收金额 -->
        <el-table-column prop="revAmount" :label="$t('lang.lab_receivedArrear')">
          <template slot-scope="scope">{{scope.row.revAmount|rounding}}</template>
        </el-table-column>
         <!-- 已收金额 -->
        <el-table-column prop="paidAmount" :label="$t('lang.lab_received')">
          <template slot-scope="scope">{{scope.row.paidAmount|rounding}}</template>
        </el-table-column>
        <!-- 责任人 -->
        <el-table-column prop="responsiblePerson" label="责任人" width="100"></el-table-column>
        <!-- 第二责任人 -->
        <el-table-column prop="responsiblePersonSecond" label="第二责任人" width="110"></el-table-column>
        <!-- 欠款原因 -->
        <el-table-column prop="reasonArrears" label="欠款原因" width="120" show-overflow-tooltip></el-table-column>
        <!-- 欠费原因2 -->
        <el-table-column prop="reasonArrearsSecond" label="欠费原因2" width="120" show-overflow-tooltip></el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50,1000]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      :title="changeTitle"
      @closed="handleDialogClosed"
    >
      <el-form ref="form" :model="form" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon" :rules="rules" class="form_show">
        <el-form-item :label="$t('lang.lab_oweStartTime')" prop="minStartDate">
          <div class="block">
            <el-date-picker v-model="form.minStartDate" type="date" value-format="timestamp" :placeholder="$t('lang.lab_please_Select') + $t('lang.lab_oweStartTime')" class="input"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_oweEndTimes')" prop="minEndDate">
          <div class="block">
            <el-date-picker v-model="form.minEndDate" type="date" value-format="timestamp" :placeholder="$t('lang.lab_please_Select') + $t('lang.lab_oweEndTimes')" class="input"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_amountOwed')" prop="receiveAmount">
          <el-input v-model="form.receiveAmount" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_amountOwed')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_adjustCause')" prop="adjustReason">
          <el-input v-model="form.adjustReason" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_adjustCause')" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="addAdjust('form')" >{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
    <!-- 批量责任人 -->
    <el-dialog
      :visible.sync="showResponsiblePerson"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      title="批量责任人"
      @closed="handleResponsiblePersonDialogClosed"
    >
      <el-form :model="form" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon" class="form_show">
        <el-form-item label="责任人" prop="responsiblePerson">
          <el-input v-model="form.responsiblePerson" placeholder="请输入责任人"></el-input>
        </el-form-item>
        <el-form-item label="第二责任人" prop="responsiblePersonSecond">
          <el-input v-model="form.responsiblePersonSecond" placeholder="请输入第二责任人"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="saveBatchResponsiblePerson()">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
    <!-- 批量欠款原因 -->
    <el-dialog
      :visible.sync="showReasonArrears"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      title="批量欠款原因"
      @closed="handleReasonArrearsDialogClosed"
    >
      <el-form :model="form" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon" class="form_show">
        <el-form-item label="欠款原因" prop="reasonArrears">
          <el-input v-model="form.reasonArrears" type="textarea" placeholder="请输入欠款原因"></el-input>
        </el-form-item>
        <el-form-item label="欠费原因2" prop="reasonArrearsSecond">
          <el-input v-model="form.reasonArrearsSecond" type="textarea" placeholder="请输入欠费原因2"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="saveBatchReasonArrears()">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
 import {
    excelDownload
  } from '../../../config/download.js'
/**
 *@ClassName:
 *@Description
 *@author:xubz
 *@Copyright:格众科技
 *@date:2021
 */
const FEE_RECEIVE_QUERY_FILTER_KEY = 'feeReceiveQuery_filter'

export default {
  name: 'feeReceiveQuery',
  data() {
    return {
      isRelationButton:this.$store.getters.isRelationButton,
      switchValue:false,
      isFeeManager:0,
      searchFeeName:'',
      multipleSelection: [], // 多选框
      editableTabs: [], // tabs列表
      datevalues: [], // 开始结束时间绑定值
      houseId: '', // 楼层绑定值
      floorList: [], // 楼层下拉列表
      unitid: '', // 单元绑定值
      unitList: [], // 单元下拉列表
      roomid: '', // 房间绑定值
      roomList: [], // 房间下拉列表
      user: '0', // 身份
      tag: '0', // 标签
      keyword: '', // 手机或序号内容input
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      type: 1, // 楼号单元号房间号区分
      parentId: '',
      gardenId: '', // 小区编号
      Identitys: this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE'), // 身份列表
      receiveArrearSelects: [
        { value: '0', label: '欠款合计<>0' },
        { value: '1', label: '欠款合计=0' }
      ],
      appHouseholdManageListcheckbox: true, // 是否隐藏复选框
      receiveAmountCount: '',
      revAmountCount: '',
      paidAmountCount: '',
      receiveArrearSelect: '0',
      startTime: '',
      endTime: '',
      form: {
        minStartDate: '', 
        minEndDate:'',
        receiveAmount:'',
        // revAmount:'',
        paidAmount:'',
        adjustReason: '', 
        rId:'',
        feeId:'',
        responsiblePerson: '',
        responsiblePersonSecond: '',
        reasonArrears: '',
        reasonArrearsSecond: ''
      },
      show: false, // 提醒的弹框
      showResponsiblePerson: false,
      showReasonArrears: false,
      rules: {
        minStartDate: [
          { required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_oweStartTime'), trigger: 'blur' }
        ],
        minEndDate: [
          { required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_oweEndTimes'), trigger: 'blur' }
        ],
        receiveAmount: [
          { required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_amountOwed'), trigger: 'blur' }
        ],
        adjustCause: [
          { required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_adjustCause'), trigger: 'blur' }
        ]
      },
      changeTitle: '', // 弹框的title
      selectCode:'',
      checkObj:{}
    }
  },
  created() {
    this.isFeeManager = this.$store.getters.isFeeManager
    // 小区编号
    this.gardenId = this.$store.getters.gardenId
    this.editableTabs = this.$store.getters.getTabList
    this.initPageWithFilterCache()
  },
  beforeRouteLeave(to, from, next) {
    this.saveFilterCache()
    next()
  },
  deactivated() {
    this.saveFilterCache()
  },
  // 监听改变小区编号
  watch: {
    '$store.state.allGardenId': function (newFlag, oldFlag) {
      this.gardenId = this.$store.state.allGardenId
      this.gardenChange()
    },
    '$store.state.tabList': function (newFlag, oldFlag) {
      this.editableTabs = this.$store.getters.getTabList
    },
  },
  computed:{
    canCombinedPay(){
      if(!this.multipleSelection || this.multipleSelection.length < 1){
        return false
      }
      const first = this.multipleSelection[0] || {}
      return this.multipleSelection.every(item=>item.ownerName===first.ownerName && item.mobile===first.mobile)
    }
  },
  methods: {
    // clikcRadio(rId){
    //   if(this.selectCode == rId){
    //     this.selectCode=''
    //   }else{
    //     this.selectCode=rId
    //   }
    // },
    // singleElection(row, column, event) {
    //   debugger
    //   if (event.target.tagName === 'INPUT') {
    //          return
    //   } 
    //   if(this.selectCode == row.rId){
    //     this.selectCode=''
    //   }else{
    //     this.selectCode=row.rId
    //   }
    //   this.checkObj={}
    //   if(this.selectCode!=''){
    //     let list = this.tableData.filter((item) => item.rId === row.rId);
    //     this.checkObj = list[0];
    //     console.log('选中的单行数据：', this.checkObj);
    //   }else{
    //     this.selectCode=''
    //   }
     
    // },

    addAdjust(form) {
        let loading = this.$loading()
        this.$postJson(`/updateBillAdjust`, this.form).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success(this.$i18n.t('lang.lab_save_success'))
              this.show = false
              this.topics()
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
    },
        // 弹框监听关闭
    handleDialogClosed() {
      this.form.minStartDate = ''
      this.form.minEndDate = ''
      this.form.receiveAmount = ''
      this.form.responsiblePerson = ''
      this.form.responsiblePersonSecond = ''
      this.form.reasonArrears = ''
      this.form.reasonArrearsSecond = ''
      if (this.$refs.form) this.$refs.form.clearValidate()
    },
    handleResponsiblePersonDialogClosed() {
      this.form.responsiblePerson = ''
      this.form.responsiblePersonSecond = ''
    },
    handleReasonArrearsDialogClosed() {
      this.form.reasonArrears = ''
      this.form.reasonArrearsSecond = ''
    },
    openBatchResponsiblePerson() {
      this.form.responsiblePerson = ''
      this.form.responsiblePersonSecond = ''
      this.showResponsiblePerson = true
    },
    openBatchReasonArrears() {
      this.form.reasonArrears = ''
      this.form.reasonArrearsSecond = ''
      this.showReasonArrears = true
    },
    saveBatchResponsiblePerson() {
      const rIds = this.multipleSelection.map(r => r.rId)
      const payload = {
        rIds,
        responsiblePerson: this.form.responsiblePerson || '',
        responsiblePersonSecond: this.form.responsiblePersonSecond || ''
      }
      let loading = this.$loading()
      this.$postJson(`/updateBillAdjust`, payload).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.$message.success(this.$i18n.t('lang.lab_save_success'))
            this.showResponsiblePerson = false
            this.topics()
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    saveBatchReasonArrears() {
      const rIds = this.multipleSelection.map(r => r.rId)
      const payload = {
        rIds,
        reasonArrears: this.form.reasonArrears || '',
        reasonArrearsSecond: this.form.reasonArrearsSecond || ''
      }
      let loading = this.$loading()
      this.$postJson(`/updateBillAdjust`, payload).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.$message.success(this.$i18n.t('lang.lab_save_success'))
            this.showReasonArrears = false
            this.topics()
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    batchDelete() {
      const hasPaid = this.multipleSelection.some(
        (r) => (parseFloat(r.paidAmount) || 0) !== 0
      )
      if (hasPaid) {
        this.$message.warning('存在未完成缴费不能删除')
        return
      }
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        const rIds = this.multipleSelection.map((r) => r.rId)
        const loading = this.$loading()
        this.$postJson(`/delFeeReceive`, { rIds }).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success(this.$i18n.t('lang.lab_del_success'))
              this.topics()
            } else {
              this.$message.error(res && res.errMsg ? res.errMsg : '删除失败')
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      }).catch(() => {})
    },
    adjust() {
      if(this.$refs.form){
        this.$nextTick(() => {
            this.$refs.form.clearValidate()
        })
      }
      if(this.multipleSelection.length>1){
        this.$message.info('请选择一条数据进行调整')
            return
      }else{
        this.changeTitle = this.$i18n.t('lang.lab_adjust')
        this.form.minStartDate=this.multipleSelection[0].minStartDate
        this.form.minEndDate=this.multipleSelection[0].minEndDate
        this.form.receiveAmount=this.multipleSelection[0].receiveAmount
        this.form.paidAmount=this.multipleSelection[0].paidAmount 
        // this.form.revAmount=parseFloat(this.multipleSelection[0].receiveAmount)-parseFloat(this.multipleSelection[0].paidAmount)
        this.form.rId=this.multipleSelection[0].rId
        this.form.feeId=this.multipleSelection[0].feeId
        this.form.adjustReason=this.multipleSelection[0].adjustReason
        this.show=true
      }
      
    },
    excelDownloadClick() {
        if (navigator.onLine) {
          // Excel表头
          const tHeader = [
            this.$i18n.t('lang.lab_username'),
            this.$i18n.t('lang.lab_phone'),
            this.$i18n.t('lang.lab_village'),
            this.$i18n.t('lang.lab_buildingnum'),
            this.$i18n.t('lang.resourUnit'),
            this.$i18n.t('lang.lab_roomnum'),
            this.$i18n.t('lang.lab_preHouseholdArea'),
            this.$i18n.t('lang.lab_feeName'),

            this.$i18n.t('lang.lab_price'),
            this.$i18n.t('lang.lab_feePeriodCount'),

            this.$i18n.t('lang.lab_startTimes'),
            this.$i18n.t('lang.lab_endTimes'),
            this.$i18n.t('lang.lab_oweStartTime'),
            this.$i18n.t('lang.lab_oweEndTimes'),
            this.$i18n.t('lang.lab_amountOwed'),
            this.$i18n.t('lang.lab_receivedArrear'),
            this.$i18n.t('lang.lab_received'),
          ]
          let newArr = []
          let minStartDate = ''
          let beginDate = ''
          let minEndDate = ''
          let payMethod = ''
          if (this.tableData.length > 0) {
            for (let i = 0; i < this.tableData.length; i++) {
           
              if (this.tableData[i].beginDate) {
                  beginDate = this.$options.filters['timeYMD'](this.tableData[i].beginDate)
              }
              if (this.tableData[i].minEndDate) {
                  minEndDate = this.$options.filters['timeYMD'](this.tableData[i].minEndDate)
              } 
              if (this.tableData[i].minStartDate) {
                  minStartDate = this.$options.filters['timeYMD'](this.tableData[i].minStartDate)
              }
              newArr.push({
                'ownerName': this.tableData[i].ownerName,
                'mobile': this.tableData[i].mobile,
                'gardenName': this.tableData[i].gardenName,
                'houseName': this.tableData[i].houseName,
                'unitName': this.tableData[i].unitName,
                'roomName': this.tableData[i].roomName,
                'buildArea': this.tableData[i].buildArea,
                'feeName': this.tableData[i].feeName,

                'squarePrice': this.tableData[i].squarePrice,
                'period': this.tableData[i].period,
                'beginDate': beginDate,
                'minEndDate': minEndDate,
                'minStartDate':minStartDate,
                'minEndDate': minEndDate,
                'receiveAmount': this.tableData[i].receiveAmount,
                'revAmount': this.tableData[i].revAmount,
                'paidAmount': this.tableData[i].paidAmount
              })
            }
          }


          // 对应table数据的列字段名
          const filterVal = ['ownerName', 'mobile', 'gardenName', 'houseName', 'unitName', 'roomName', 'buildArea','feeName',
          'squarePrice','period','beginDate','minEndDate','minStartDate','minEndDate','receiveAmount','revAmount','paidAmount'
          ]
          excelDownload(tHeader, filterVal, newArr, "应收查询报表")
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
    // 初始化时间组件
    getDatePicker() {
       let d = new Date()
      let year1, month1, day1
      [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, 0]
      let date1 = new Date(year1, month1, day1).getTime()
      // this.datevalues.push(Date.parse(date1))
      this.endTime = date1
      // 前一天设定的日期时间
      let year2, month2, day2
      [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1]
      let date2 = new Date(year2, month2, day2).getTime()
      // this.datevalues.unshift(Date.parse(date2))
       this.startTime = date2
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 添加多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    combinedPay(){
      if(!this.canCombinedPay){
        this.$message.error('请选择同一用户名和手机号的记录')
        return
      }
      this.saveFilterCache()
      try{
        window.localStorage.setItem('combinedPaySelection',JSON.stringify(this.multipleSelection))
      }catch(e){
        console.warn('save combinedPaySelection fail',e)
      }
      this.$router.push({
        name:'feeCombinedPay',
        query:{combinedPay:1}
      })
    },
    saveFilterCache() {
      try {
        const payload = {
          gardenId: this.gardenId,
          startTime: this.startTime,
          endTime: this.endTime,
          houseId: this.houseId,
          unitid: this.unitid,
          roomid: this.roomid,
          receiveArrearSelect: this.receiveArrearSelect,
          searchFeeName: this.searchFeeName,
          keyword: this.keyword
        }
        window.sessionStorage.setItem(FEE_RECEIVE_QUERY_FILTER_KEY, JSON.stringify(payload))
      } catch (e) {
        console.warn('save feeReceiveQuery filter fail', e)
      }
    },
    restoreFilterCache() {
      try {
        const raw = window.sessionStorage.getItem(FEE_RECEIVE_QUERY_FILTER_KEY)
        if (!raw) {
          return false
        }
        const data = JSON.parse(raw)
        if (data.gardenId == null || String(data.gardenId) !== String(this.gardenId)) {
          return false
        }
        this.startTime = data.startTime || ''
        this.endTime = data.endTime || ''
        this.houseId = data.houseId || ''
        this.unitid = data.unitid || ''
        this.roomid = data.roomid || ''
        this.receiveArrearSelect = data.receiveArrearSelect != null ? String(data.receiveArrearSelect) : '0'
        this.searchFeeName = data.searchFeeName || ''
        this.keyword = data.keyword || ''
        return true
      } catch (e) {
        console.warn('restore feeReceiveQuery filter fail', e)
        return false
      }
    },
    async initPageWithFilterCache() {
      const restored = this.restoreFilterCache()
      if (!restored) {
        this.getDatePicker()
      }
      let loading = this.$loading()
      try {
        this.type = 1
        await this.fetchGardenGrids(this.gardenId)
        if (restored && this.houseId) {
          this.type = 2
          await this.fetchGardenGrids(this.houseId)
        }
        if (restored && this.unitid) {
          this.type = 3
          await this.fetchGardenGrids(this.unitid)
        }
      } catch (error) {
        this.$message.error(error)
      } finally {
        loading.close()
      }
      this.topics()
    },
    // 改变小区
    gardenChange() {
      this.houseId = ''
      this.unitid = ''
      this.roomid = ''
      this.unitList = ''
      this.roomList = ''
      this.type = 1
      this.saveFilterCache()
      this.gardenGrids(this.gardenId)
      this.topics()
    },
    fetchGardenGrids(parentId) {
      return this.$get(
        `/gardenGrids?type=${this.type}&parentId=${parentId}&pageNo=1&pageSize=999`
      ).then((res) => {
        if (res && res.errCode === 0) {
          if (this.type === 1) {
            this.floorList = res.list
          } else if (this.type === 2) {
            this.unitList = res.list
            this.roomList = ''
            if (this.houseId === '') {
              this.unitList = ''
              this.roomList = ''
            }
          } else if (this.type === 3) {
            this.roomList = res.list
            if (this.unitid === '') {
              this.roomList = ''
            }
          }
        }
        return res
      })
    },
    // 获取楼号单元号房间号
    gardenGrids(parentId) {
      let loading = this.$loading()
      this.fetchGardenGrids(parentId).then(
        () => {
          loading.close()
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    topics() {
      var startTs = ''
      var endTs = ''
      // if (this.datevalues != null) {
      //   if (this.datevalues.length > 0) {
      //     startTs = this.datevalues[0]
      //     endTs = this.datevalues[1]
      //   }
      // }
      if(this.startTime!=''&&this.startTime!=null&&this.startTime!=undefined){
           startTs =this.startTime
      }
       if(this.endTime!=''&&this.endTime!=null&&this.endTime!=undefined){
           endTs =this.endTime
      }
      let loading = this.$loading()
      this.$get(
        `/feeReceiveListByGardenId?pageNo=${this.pageNo}&pageSize=${this.pageSize}&gardenId=${this.gardenId}&houseId=${this.houseId}&unitId=${this.unitid}&roomId=${this.roomid}&userType=${this.user}&key=${this.keyword}&tagId=${this.tag}&startTs=${startTs}&endTs=${endTs}
        &feeName=${this.searchFeeName}&isWaiver=${this.switchValue}&receiveArrearSelect=${this.receiveArrearSelect}`
      ).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.receiveAmountCount = ''
            this.revAmountCount = ''
            this.paidAmountCount = ''
            console.log(res.list)
            this.tableData = res.list
            this.pageCount = res.pageCount
            if (res.list != null && res.list.length > 0) {
                this.receiveAmountCount = res.list[0].receiveAmountCount
                this.revAmountCount = res.list[0].revAmountCount
                this.paidAmountCount = res.list[0].paidAmountCount
            }
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 提交
    submit() {
      this.pageNo = 1
      this.saveFilterCache()
      this.topics()
    },
    // 通过楼层选择单元号
    selectUnit() {
      this.type = 2
      this.gardenGrids(this.houseId)
      this.unitid = ''
      this.roomid = ''
    },
    // 通过单元选择房间号
    selectRoom() {
      this.type = 3
      this.gardenGrids(this.unitid)
      this.roomid = ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.topics()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.topics()
    },
  },
  filters: {
    rounding (value) {
      if (value == undefined || value == '') {
          value = 0
      }
     return value.toFixed(2)
    }
  }
}
</script>

<style lang= 'scss'>
</style>
